var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('p',{attrs:{"id":"version"}},[_vm._v("© 2024 Masterwork Aoitek Tech Corp Ltd. "+_vm._s(_vm.version))])])
}
var staticRenderFns = []

export { render, staticRenderFns }